import { useFormik } from "formik";
import { RecurlyFields } from "../../../../../contracts/recurly-api/consts";
import FormSchema from "./form-schema";
import { useTranslation } from "react-i18next";

export const SUBSCRIPTION_FORM_FIELDS: {
  [k: string]: {
    key: keyof SubscriptionFormValues;
    recurlyData: RecurlyFields;
  };
} = {
  FIRST_NAME: { key: "firstName", recurlyData: RecurlyFields.FirstName },
  LAST_NAME: { key: "lastName", recurlyData: RecurlyFields.LastName },
  EMAIL: { key: "email", recurlyData: RecurlyFields.Email },
  CARD_NUMBER: { key: "cardNumber", recurlyData: RecurlyFields.Number },
  // CARD_EXPIRATION: { key: "expirationDate" },
  CARD_EXP_MONTH: {
    key: "expirationDateMonth",
    recurlyData: RecurlyFields.Month,
  },
  CARD_EXP_YEAR: { key: "expirationDateYear", recurlyData: RecurlyFields.Year },
  CVV: { key: "cvv", recurlyData: RecurlyFields.CVV },
  COUNTRY: { key: "country", recurlyData: RecurlyFields.Country },
  ADDRESS: { key: "address", recurlyData: RecurlyFields.Address },
  CITY: { key: "city", recurlyData: RecurlyFields.City },
  STATE: { key: "state", recurlyData: RecurlyFields.State },
  ZIP: { key: "zipcode", recurlyData: RecurlyFields.PostalCode },
};

export type SubscriptionFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  cardNumber: string;
  expirationDateMonth: number;
  expirationDateYear: number;
  cvv: number;
  country: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
};

export function useSubscriptionFormik() {
  const { t } = useTranslation();

  const formik = useFormik<SubscriptionFormValues>({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      cardNumber: "",
      expirationDateMonth: 0,
      expirationDateYear: 0,
      cvv: 0,
      country: "US",
      address: "",
      city: "",
      state: "",
      zipcode: "",
    },
    onSubmit: async (values, formikHelpers) => {},
    validateOnChange: false,
    validationSchema: FormSchema(t),
  });

  return formik;
}

type RecurlyField = {
  field: RecurlyFields;
  messages: string[];
};

/**
 * Create an object indexing each item of SUBSCRIPTION_FORM_FIELDS by its recurlyData field
 */
function createRecurlyMapFields(): {
  [k in RecurlyFields]: keyof SubscriptionFormValues;
} {
  const mapFields: { [k in RecurlyFields]: any } = {
    first_name: undefined,
    last_name: undefined,
    email: undefined,
    number: undefined,
    month: undefined,
    year: undefined,
    cvv: undefined,
    country: undefined,
    address1: undefined,
    city: undefined,
    state: undefined,
    postal_code: undefined,
  };
  Object.keys(SUBSCRIPTION_FORM_FIELDS).forEach((name) => {
    const item = SUBSCRIPTION_FORM_FIELDS[name];
    if (item.recurlyData) {
      mapFields[item.recurlyData] = item.key;
    }
  });
  return mapFields;
}
function capitalize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function convertRecurlyErrors(details: RecurlyField[]) {
  const fieldsMap = createRecurlyMapFields();
  const errors: { [k in keyof SubscriptionFormValues]?: string } = {};

  details?.forEach((item) => {
    const { field, messages } = item;
    // Get the field configuration by the recurly field id
    const fieldMapped = fieldsMap[field];
    errors[fieldMapped] = `${capitalize(field)} ${messages[0]}`;
  });

  return errors;
}
